import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { brandAccentInputClassName } from '@/shared/config/theme';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
}

export default function Checkbox({ className, label, id, ...props }: CheckboxProps) {
  const input = (
    <input
      type="checkbox"
      id={id}
      className={cn(
        'h-5 w-5 shrink-0 cursor-pointer rounded border-gray-300',
        brandAccentInputClassName,
        className,
      )}
      {...props}
    />
  );

  if (!label) {
    return input;
  }

  return (
    <label htmlFor={id} className="flex cursor-pointer items-center gap-2">
      {input}
      <span>{label}</span>
    </label>
  );
}
